var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 20 0 20 24 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26193932,17.6476484         C5.90425297,18.0684559 5.27315905,18.1196257         4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159         4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855         14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907         C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638         C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093         L14.0997854,8.42665306 L6.26193932,17.6476484 Z",
    fill: "#000",
    fillRule: "nonzero",
    transform: "translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBlack);
export default __webpack_public_path__ + "static/media/select_black.790c2b1bc29aa7dcf6532fb91d90160d.svg";
export { ForwardRef as ReactComponent };